import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/lib/seo";
import { Reveal } from "@/lib/motion";

export default function NoEncontrado() {
  return (
    <>
      <Seo
        title="Página no encontrada"
        description="La página que buscas no existe o se movió. Vuelve al inicio, explora los momentos de vida o cuéntanos tu situación."
        path="/404"
      />
      <section className="bg-parchment">
        <div className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-8 sm:py-32">
          <Reveal>
            <p className="eyebrow mb-6">Error 404</p>
            <h1 className="font-serif text-5xl leading-tight text-ink-deep sm:text-6xl">
              Esta ruta no lleva a ningún asunto
            </h1>
            <p className="mx-auto mt-6 max-w-md text-ink-muted">
              La página que buscas no existe o se movió. Por suerte, lo importante no se pierde aquí.
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Link to="/" data-testid="404-link-inicio" className="btn-primary">
                Volver al inicio
                <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/orientador" data-testid="404-link-orientador" className="btn-secondary">
                Encuentra tu ruta
              </Link>
            </div>
            <p className="mt-10 font-mono text-xs text-ink-muted">
              O si prefieres:{" "}
              <Link to="/contacto" data-testid="404-link-contacto" className="text-azul underline underline-offset-4">
                cuéntanos tu situación
              </Link>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
